(() => {
  const roots = document.querySelectorAll("[data-et-sale-pop]");
  if (!roots.length) return;

  function splitList(value) {
    return String(value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function pick(list) {
    if (!list || !list.length) return "";
    return list[Math.floor(Math.random() * list.length)];
  }

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function isCartDrawerOpen() {
    const drawer = document.querySelector("cart-drawer");

    if (!drawer) return false;

    return (
      drawer.hasAttribute("open") ||
      drawer.classList.contains("is-open") ||
      drawer.classList.contains("show-close-cursor") ||
      drawer.getAttribute("aria-hidden") === "false"
    );
  }

  roots.forEach((root) => {
    const configNode = document.querySelector("[data-et-sale-pop-config]");
    const productsNode = document.querySelector("[data-et-sale-pop-products]");

    if (!configNode || !productsNode) return;

    let config = {};
    let products = [];

    try {
      config = JSON.parse(configNode.textContent || "{}");
    } catch (error) {
      console.error("[sale-notification] Invalid config JSON", error);
      return;
    }

    try {
      products = JSON.parse(productsNode.textContent || "[]").filter((product) => {
        return product.title && product.url && product.image;
      });
    } catch (error) {
      console.error("[sale-notification] Invalid products JSON", error);
      return;
    }

    if (!products.length) {
      console.warn("[sale-notification] No products selected.");
      return;
    }

    if (root.classList.contains("et-sale-pop--hide-mobile") && isMobile()) {
      return;
    }

    const names = splitList(config.randomNames);
    const locations = splitList(config.randomLocations);
    const timestamps = splitList(config.randomTimestamps);

    const link = root.querySelector("[data-et-sale-pop-link]");
    const image = root.querySelector("[data-et-sale-pop-image]");
    const meta = root.querySelector("[data-et-sale-pop-meta]");
    const productTitle = root.querySelector("[data-et-sale-pop-product]");
    const time = root.querySelector("[data-et-sale-pop-time]");
    const badge = root.querySelector("[data-et-sale-pop-badge]");
    const closeButton = root.querySelector("[data-et-sale-pop-close]");

    const sectionId = root.dataset.sectionId || "default";
    const storageKey = `eterlove_sale_notification_closed_until_${sectionId}`;

    const firstDelay = Number(config.firstDelay || 15) * 1000;
    const displayTime = Number(config.displayTime || 6) * 1000;
    const delayBetween = Number(config.delayBetween || 60) * 1000;
    const closeMinutes = Number(config.closeMinutes || 10) * 60 * 1000;

    let firstTimer = null;
    let intervalTimer = null;
    let hideTimer = null;

    root.style.setProperty("--et-sale-display-time", `${displayTime}ms`);

    function isClosedByUser() {
      const until = Number(localStorage.getItem(storageKey) || 0);
      return Date.now() < until;
    }

    function hide() {
      root.classList.remove("is-visible");
      root.setAttribute("hidden", "");
    }

    function buildTitle(name, location) {
  const safeName = name || "Customer";
  const safeLocation = location || "United States";

  return String(config.titleTemplate || "{name} from {location} recently ordered")
    .replaceAll("{name}", safeName)
    .replaceAll("{location}", safeLocation)
    .replaceAll("{{name}}", safeName)
    .replaceAll("{{location}}", safeLocation);
}

    function show() {
      if (isClosedByUser()) return;
      if (isCartDrawerOpen()) return;
      if (root.classList.contains("et-sale-pop--hide-mobile") && isMobile()) return;

      const selectedProduct = pick(products);
      const selectedName = pick(names) || "Customer";
      const selectedLocation = pick(locations) || "United States";
      const selectedTime = pick(timestamps) || "12 minutes ago";

      if (!selectedProduct) return;

      link.href = selectedProduct.url;

      if (config.openNewTab) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      } else {
        link.removeAttribute("target");
        link.removeAttribute("rel");
      }

      image.src = selectedProduct.image;
      image.alt = selectedProduct.title;

      meta.textContent = buildTitle(selectedName, selectedLocation);
      productTitle.textContent = selectedProduct.title;
      time.textContent = selectedTime;

      if (badge) {
        badge.textContent = config.verifiedText || "verified";
      }

      root.removeAttribute("hidden");

      requestAnimationFrame(() => {
        root.classList.add("is-visible");
      });

      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, displayTime);
    }

    function start() {
      clearTimeout(firstTimer);
      clearInterval(intervalTimer);

      firstTimer = setTimeout(() => {
        show();

        intervalTimer = setInterval(() => {
          show();
        }, delayBetween);
      }, firstDelay);
    }

    closeButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      hide();

      localStorage.setItem(
        storageKey,
        String(Date.now() + closeMinutes)
      );
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        hide();
      }
    });

    const drawer = document.querySelector("cart-drawer");

    if (drawer) {
      const observer = new MutationObserver(() => {
        if (isCartDrawerOpen()) hide();
      });

      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ["open", "class", "aria-hidden"]
      });
    }

    start();
  });
})();